/* pi-menu-drawer.js — Aurora left drawer ================================= */
(function () {
  if (window.customElements.get('pi-menu-drawer')) return;

  class PiMenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.panels = [];
      this.history = ['root'];
      this.untrap = null;
      this.trigger = null;
      this.dialog = null;
    }

    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.pi-menu-panel'));
      this.dialog = this.querySelector('.pi-menu-drawer__dialog');
      this.closeBtns = this.querySelectorAll('[data-pi-menu-close]');
      this.backBtns = this.querySelectorAll('[data-pi-menu-back]');
      this.triggers = this.querySelectorAll('[data-pi-submenu]');

      this.bindOpeners();
      this.bindControls();
    }

    bindOpeners() {
      document.querySelectorAll('[data-pi-menu-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.dataset.open === 'true') {
            this.close();
          } else {
            this.open(btn);
          }
        });
      });
    }

    bindControls() {
      this.closeBtns.forEach((b) => b.addEventListener('click', () => this.close()));
      this.backBtns.forEach((b) =>
        b.addEventListener('click', () => this.pop())
      );
      this.triggers.forEach((t) =>
        t.addEventListener('click', (e) => {
          e.preventDefault();
          const target = t.getAttribute('data-pi-submenu');
          if (target) this.push(target);
        })
      );

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.dataset.open === 'true') this.close();
      });
    }

    open(triggeredBy) {
      this.trigger = triggeredBy || null;
      this.dataset.open = 'true';
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pi-menu-drawer-open');
      if (triggeredBy) triggeredBy.setAttribute('aria-expanded', 'true');
      this.history = ['root'];
      this.activatePanel('root');
      const focusRoot = this.dialog || this;
      if (window.PiUtils) {
        window.PiUtils.lockScroll(this);
        this.untrap = window.PiUtils.trapFocus(
          this,
          focusRoot.querySelector('.pi-menu-panel__link, .pi-menu-panel__trigger')
        );
      } else if (this.isMobileViewport()) {
        document.body.classList.add('overflow-hidden-mobile');
      }
    }

    close() {
      this.dataset.open = 'false';
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('pi-menu-drawer-open');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      if (this.untrap) {
        this.untrap();
        this.untrap = null;
      }
      if (window.PiUtils) {
        window.PiUtils.unlockScroll(this);
      } else if (this.isMobileViewport()) {
        document.body.classList.remove('overflow-hidden-mobile');
      }
      if (this.trigger && typeof this.trigger.focus === 'function') {
        this.trigger.focus({ preventScroll: true });
      }
    }

    push(target) {
      this.history.push(target);
      this.activatePanel(target);
    }

    pop() {
      if (this.history.length <= 1) return;
      this.history.pop();
      const target = this.history[this.history.length - 1];
      this.activatePanel(target);
    }

    activatePanel(name) {
      this.panels.forEach((p) => {
        const id = p.getAttribute('data-panel');
        p.dataset.active = String(id === name);
        p.dataset.prev = String(this.history.indexOf(id) !== -1 && id !== name);
      });
    }

    isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }
  }

  window.customElements.define('pi-menu-drawer', PiMenuDrawer);
})();
